import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material';

import { I18n } from '@ngx-translate/i18n-polyfill';

import { ErrorModel, UserImageModel, UserImageResponseModel } from '../../core/api';
import { ConfirmationDialogService } from '../confirmation-dialog';

import { UserService } from '../../accounts/user/services/user.service';
import { ToastService } from '../toast';
import { HttpStatusCode } from '@core/enums/http-status-code';
import { environment } from '../../../environments/environment';
import { FormControl } from '@angular/forms';

enum State {
  Upload,
  Loading,
  Done
}

@Component({
  selector: 'ui-upload-document-photo',
  templateUrl: './upload-document-photo.component.html',
  styleUrls: ['./upload-document-photo.component.scss']
})
export class UploadDocumentPhotoComponent implements OnInit {
  static nextId = 0;

  public id = `user-upload-document-photo-${UploadDocumentPhotoComponent.nextId++}`;

  @Input() public file: UserImageResponseModel = null;
  @Input() public control: FormControl = null;
  @Input() public disabled = false;
  @Input() public loading = false;
  @Input() public placeholder = '';
  @Input() public fileAccept = 'images/*';

  @Input() public inline = false;

  states: typeof State = State;

  @Input() public type: UserImageModel.TypeEnum;

  @ViewChild('fileInput') fileInput: HTMLInputElement;

  @Output() selectFile = new EventEmitter();

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private userService: UserService,
    private toastService: ToastService,
    private i18n: I18n
  ) { }

  public get state() {
    if (this.loading) {
      return State.Loading;
    }

    if (this.file) {
      return State.Done
    }

    return State.Upload;
  }

  public onSelectFile(fileList: FileList){
    const file = fileList.item(0);

    if (file.size > environment.maxUploadFileSize) {
      return this.control.setErrors({ maxUploadFileSize: true });
    }

    return this.selectFile.emit({
      image: file,
      type: this.type,
      start: () => this.loading = true,
      stop: () => this.loading = false,
    });
  }

  public onRequestFile(input: HTMLInputElement, fileList: FileList) {
    this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Отмена'),
      confirmBtnText: this.i18n('Заменить'),
      message: this.i18n('Вы действительно хотите заменить фото документа?'),
      title: this.i18n('Запрос на изменение данных')
    })
      .then(() => {
        if (fileList) {
          return this.onSelectFile(fileList);
        }

        input.click();
      })
      .catch(error => {

      });
  }

  public onDragOver(btn: MatButton): void {
    btn.ripple.launch({ centered: true, persistent: true });
  }

  public onDragLeave(btn: MatButton): void {
    btn.ripple.fadeOutAll();
  }

  ngOnInit() {
  }

}
